import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_TELEFON_ENTFERNEN_ADMIN = '[BenutzerverwaltungModul] PostBenutzerTelefonEntfernenAdmin laden';
export const POST_BENUTZER_TELEFON_ENTFERNEN_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerTelefonEntfernenAdmin ausführen';
export const POST_BENUTZER_TELEFON_ENTFERNEN_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerTelefonEntfernenAdmin laden erfolgreich';
export const POST_BENUTZER_TELEFON_ENTFERNEN_ADMIN_FEHLER = '[BenutzerverwaltungModul] PostBenutzerTelefonEntfernenAdmin Ladefehler';
export const POST_BENUTZER_TELEFON_ENTFERNEN_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerTelefonEntfernenAdmin nicht ausgeführt (evtl. Offline)';


export class PostBenutzerTelefonEntfernenAdminAction implements Action {
    readonly type = POST_BENUTZER_TELEFON_ENTFERNEN_ADMIN;
        constructor(public benutzerTelefonEntfernenRequest: api.BenutzerTelefonEntfernenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefonEntfernenAdminAusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_TELEFON_ENTFERNEN_ADMIN_AUSFUEHREN;
        constructor(public benutzerTelefonEntfernenRequest: api.BenutzerTelefonEntfernenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefonEntfernenAdminErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_TELEFON_ENTFERNEN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public benutzerTelefonEntfernenRequest: api.BenutzerTelefonEntfernenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefonEntfernenAdminFehlerAction implements Action {
    readonly type = POST_BENUTZER_TELEFON_ENTFERNEN_ADMIN_FEHLER;
        constructor(public payload: any, public benutzerTelefonEntfernenRequest: api.BenutzerTelefonEntfernenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefonEntfernenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_TELEFON_ENTFERNEN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerTelefonEntfernenAdminActions =
    PostBenutzerTelefonEntfernenAdminAction
    | PostBenutzerTelefonEntfernenAdminAusfuehrenAction
    | PostBenutzerTelefonEntfernenAdminErfolgreichAction
    | PostBenutzerTelefonEntfernenAdminFehlerAction
    | PostBenutzerTelefonEntfernenAdminNichtAusgefuehrtAction
    ;
